import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CourseResponse, Element, ElementData, Session } from '@app/core/models/courses.model';
import { CourseService } from '@app/core/services/course.service';
import { safeEmpty } from '@app/shared/utils';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';
import { CourseSelectors } from '../store';

export interface CourseResolverData {
  courseResponse: CourseResponse;
  selectedSession: Session;
  selectedElement: Element;
  selectedElementData: ElementData;
}

export const courseResolver: ResolveFn<CourseResolverData> = (route, state) => {
  const courseService = inject(CourseService);
  const store = inject(Store);

  return store.select(CourseSelectors.courseActive).pipe(
    switchMap(() => courseService.getTrail(route.params.event_id, route.params.trail_slug)),
    safeEmpty(),
    switchMap((course) => {
      const data: CourseResolverData = {
        courseResponse: undefined,
        selectedSession: undefined,
        selectedElement: undefined,
        selectedElementData: undefined,
      };

      data.courseResponse = { ...course, vitrine: false };
      data.selectedSession =
        course.porcentagem < 100
          ? course.sessoes.find((s) => s.elementos.some((e) => e.finalizado === 0)) ?? course.sessoes[0]
          : course.sessoes[0];
      data.selectedElement = data.selectedSession.elementos.some((e) => e.finalizado === 0)
        ? data.selectedSession.elementos.find((e) => e.finalizado === 0)
        : data.selectedSession.elementos[0];

      return courseService.getElement(route.params.event_id, route.params.trail_slug, data.selectedElement.slug).pipe(
        safeEmpty(),
        map((element) => {
          data.selectedElementData = element;
          return data;
        }),
      );
    }),
  );
};
